import { createValidator } from 'util/validation'

import { AvaliacaoFormModel } from '../AvaliacaoForm'

// O validator está vazio porque o atendimento de observação por auxiliares não possui a Avaliação do SOAP
export const avaliacaoObservacaoValidator = () => createValidator<AvaliacaoFormModel>({})
